import styled from 'styled-components';
import { Wrapper } from '@catalogo/theme-wrapper';

export const ThemeWrapper = styled.div`
  text-transform: ${({ theme }) => theme.titleTransform};
`;

export const LeftWrapper = styled.div`
  min-width: 22%;
  padding-left: 10px;
`;

export const WrapperBox = styled(Wrapper)`
  display: flex;
  flex-direction: row;
`;

export const Content = styled.div`
  background-color: #fff;
  margin: 0 8px 0 25px;
  width: 100%;

  > div {
    margin-top: 0;
  }
`;
